import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import React from 'react';
import { Controlled_AutocompleteReferenceTextField } from './Controlled_AutocompleteReferenceTextField';
import {
    WorkflowRepresentationEditDialog,
} from '../../../page-components/project/reusable-elements/workflow-representation/WorkflowRepresentationEditDialog';
import {
    WorkflowRepresentationCreationDialog,
} from '../../../page-components/project/reusable-elements/workflow-representation/WorkflowRepresentationCreationDialog';
import {
    useWorkflowRepresentationActions,
} from '../../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { useSystemInformationActions } from '../../../../resource/services/systemInformationService';

export const Controlled_WorkflowRepresentationTextField= ({ objectId, projectVersionId, projectId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectId: string | undefined | null;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    onChange?: (id: string | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation: PropertyValidationInformation;
}) => {

    const nestedDialog = useNestedDialogFunction();

    const workflowRepresentationActions = useWorkflowRepresentationActions();
    const systemInformationActions = useSystemInformationActions();
    const workflowRepresentationsQuery = workflowRepresentationActions.useGetAllResources(projectVersionId);
    const propertyDetails = systemInformationActions.useGetPropertyDetails(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType,
    );
    const propertyValidation = systemInformationActions.useGetPropertyValidationWithId(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType,
        propertyValidationInformation.resourceId ?? '',
    );

    const onEdit = () => {
        nestedDialog.showNestedDialog(
            <WorkflowRepresentationEditDialog
                onClose={nestedDialog.closeNestedDialog}
                objectId={objectId}
                versionedInId={projectVersionId ?? ''}
                projectId={projectId ?? ''}
            />,
        );
    };

    const onAdd = () => {
        nestedDialog.showNestedDialog(
            <WorkflowRepresentationCreationDialog
                onClose={nestedDialog.closeNestedDialog}
                parentId={projectVersionId ?? ''}
                onCreated={(_, newObjectId) => {
                    if (onChange) {
                        onChange(newObjectId);
                    }
                }}
            />,
        );
    };

    return (
        <Controlled_AutocompleteReferenceTextField
            idValue={objectId}
            readOnly={readOnly}
            onChange={onChange}
            propertyValidation={propertyValidation}
            propertyDetails={noLabel ? undefined : propertyDetails}
            query={workflowRepresentationsQuery}
            groupBy={resource => resource.type}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
            onAdd={onAdd}
            onEdit={onEdit}
        />
    );
};